import { LocalizationString } from '@6grain/masofa-monolith-api-client/common';

export interface StatusOption {
  value: number;
  label: string;
  names: LocalizationString;
}

export const APPEAL_STATUS_OPTIONS: StatusOption[] = [
  {
    value: 0,
    label: 'New',
    names: {
      'ru-RU': 'Новый',
      'en-US': 'New',
      'fr-FR': 'Nouveau',
      'uz-Latn-UZ': 'Yangi',
      'uz-Cyrl-UZ': 'Янги',
      'ar-LB': 'جديد'
    } as LocalizationString
  },
  {
    value: 1,
    label: 'In Progress',
    names: {
      'ru-RU': 'В работе',
      'en-US': 'In Progress',
      'fr-FR': 'En cours',
      'uz-Latn-UZ': 'Jarayonda',
      'uz-Cyrl-UZ': 'Жараёнда',
      'ar-LB': 'قيد التنفيذ'
    } as LocalizationString
  },
  {
    value: 2,
    label: 'Rejected',
    names: {
      'ru-RU': 'Отклонено',
      'en-US': 'Rejected',
      'fr-FR': 'Rejeté',
      'uz-Latn-UZ': 'Rad etilgan',
      'uz-Cyrl-UZ': 'Рад этилган',
      'ar-LB': 'مرفوض'
    } as LocalizationString
  },
  {
    value: 3,
    label: 'Complete',
    names: {
      'ru-RU': 'Завершено',
      'en-US': 'Complete',
      'fr-FR': 'Terminé',
      'uz-Latn-UZ': 'Tugallangan',
      'uz-Cyrl-UZ': 'Тугалланган',
      'ar-LB': 'مكتمل'
    } as LocalizationString
  }
];

